import axios from 'axios';

export function postRecetas(data, config = {}) {
    return new Promise((resolve, reject) => {
        axios
            .post(`/api/recetas`, data, config)
            .then((response) => {
                resolve(response);
            })
            .catch((error) => {
                console.error(error);
                reject(error);
            });
    });
}

/**
 * @param {string} uuid patient uuid
 */
export function getRecetas(uuid) {
    return new Promise((resolve, reject) => {
        axios
            .get(`/api/recetas/` + uuid)
            .then((response) => {
                const recetaData = response.data.data.flat();
                const formattedMedRequests = recetaData.map((medRequest) => ({
                    authoredOn: medRequest.authoredOn,
                    periodoLimiteInicio:
                        medRequest.dispenseRequest.validityPeriod.start,
                    periodoLimiteFinal:
                        medRequest.dispenseRequest.validityPeriod.end,
                    medicationQuantity: medRequest.dispenseRequest.quantity
                        ? medRequest.dispenseRequest.quantity.value
                        : null,
                    dosageInstruction: medRequest.dosageInstruction[0],
                    identifier: medRequest.identifier[0].value,
                    intent: medRequest.intent,
                    category: medRequest.category ? medRequest.category[0].coding[0].code : 'normal',
                    medicationReference: medRequest.medicationReference,
                    note: medRequest.note ? medRequest.note[0].text : null,
                    practitionerId: medRequest.requester.reference,
                    patientId: medRequest.subject.reference,
                    status: medRequest.status,
                    marca: medRequest.medicationCodeableConcept
                        ? medRequest.medicationCodeableConcept.text
                        : null,
                }));
                resolve(formattedMedRequests);
            })
            .catch((error) => {
                console.error(
                    'Error in getRecetas:',
                    error.response ? error.response.data : error.message,
                );
                reject(error);
            });
    });
}

export function getConteoRecetas(id_practicante) {
    return new Promise((resolve, reject) => {
        axios
            .get(`/api/recetas/conteo/${id_practicante}`)
            .then((response) => {
                resolve(response.data);
            })
            .catch((error) => {
                console.error(error);
                reject(error);
            });
    });
}
